/* global mixpanel */

export function knowledgeCenterStart () {
  mixpanel.track('Knowledge Center Start')
}



// WEBPACK FOOTER //
// ./app/mixpanel/zendeskLinks.js